// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { color, xClassNames, xScreen } from "@keller/XDL/Utilities";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

/**
 * XNG-Changes
 */
enum fields {
    borderBottom = "borderBottom",
}
interface OwnProps {
    fields: {
        [fields.borderBottom]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps>;

interface PageTitleStyles {
    title?: TypographyPresentationProps;
}

const pageTitleStyles: PageTitleStyles = {
    title: {
        css: css`
            ${xScreen("lte", "xs")} {
                &.border-bottom {
                    padding-bottom: 24px;
                    margin-bottom: 20px;
                    border-bottom: 1px solid ${color("common.border")};
                }
            }
        `,
    },
};

const styles = pageTitleStyles;
// XNG-Changes: Change variant to h1
const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => (
    <Typography
        variant="h1"
        as="h1"
        data-test-selector="PageTitle"
        className={xClassNames.append(fields.borderBottom && "border-bottom")}
        {...styles.title}
    >
        {fields.overrideTitle || pageTitle}
    </Typography>
);

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
        fieldDefinitions: [
            {
                name: fields.borderBottom,
                displayName: "Show Title Border On Mobile ",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 1,
                tooltip: "Add a border under the title on mobile only",
            },
        ],
    },
};

export default widgetModule;
